import { DiscountsPanel } from "../components/DiscountsPanel";
import { DiscountCodesPanel } from "../components/DiscountCodesPanel";

export function DiscountsPage() {
  return (
    <div className="o-grid2">
      <DiscountsPanel />
      <DiscountCodesPanel />
    </div>
  );
}
